import { render } from "./OperatePurchase.vue?vue&type=template&id=cb039de4"
import script from "./OperatePurchase.vue?vue&type=script&lang=js"
export * from "./OperatePurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__